// Juridische pagina's (concept-templates) voor Cleven Cleaning.
// LET OP: dit zijn concepten op maat voor een glazenwasser/schoonmaakbedrijf.
// Laat ze vóór livegang juridisch nalezen of vul aan met een branchemodel.

const COMPANY = {
  name: "Cleven Cleaning",
  kvk: "75029979",
  city: "Rosmalen",
  phone: "06 - 83 65 35 11",
  phoneClean: "0683653511",
  email: "info@clevencleaning.nl",
  site: "www.clevencleaning.nl",
};

export const legalDocs = {
  "algemene-voorwaarden": {
    slug: "algemene-voorwaarden",
    title: "Algemene Voorwaarden",
    metaTitle: "Algemene Voorwaarden | Cleven Cleaning",
    metaDescription:
      "Lees de algemene voorwaarden van Cleven Cleaning, glazenwasser en schoonmaakbedrijf in Rosmalen en omstreken.",
    updated: "februari 2026",
    intro:
      "Deze algemene voorwaarden zijn van toepassing op alle offertes, opdrachten en overeenkomsten tussen Cleven Cleaning en de opdrachtgever. Door een opdracht te verstrekken, gaat u akkoord met deze voorwaarden.",
    sections: [
      {
        heading: "Artikel 1 — Definities",
        items: [
          "Cleven Cleaning: de eenmanszaak / het bedrijf ingeschreven bij de Kamer van Koophandel onder nummer 75029979, gevestigd te Rosmalen.",
          "Opdrachtgever: de particulier, VvE of onderneming die met Cleven Cleaning een overeenkomst aangaat of daartoe een offerte aanvraagt.",
          "Werkzaamheden: alle door Cleven Cleaning aangeboden diensten, waaronder glasbewassing, kozijnreiniging, zonnepaneelreiniging, dakgootonderhoud, dak- en gevelreiniging en hogedrukreiniging.",
          "Overeenkomst: iedere afspraak tussen opdrachtgever en Cleven Cleaning tot het verrichten van werkzaamheden.",
        ],
      },
      {
        heading: "Artikel 2 — Toepasselijkheid",
        paragraphs: [
          "Deze voorwaarden zijn van toepassing op alle aanbiedingen, offertes en overeenkomsten van Cleven Cleaning. Afwijkingen gelden alleen wanneer deze schriftelijk zijn overeengekomen.",
          "Eventuele algemene voorwaarden van de opdrachtgever worden uitdrukkelijk van de hand gewezen, tenzij schriftelijk anders is overeengekomen.",
        ],
      },
      {
        heading: "Artikel 3 — Offertes en totstandkoming",
        paragraphs: [
          "Alle offertes en prijsindicaties (waaronder die via de online calculator) zijn vrijblijvend en geldig gedurende 30 dagen, tenzij anders vermeld.",
          "Een overeenkomst komt tot stand op het moment dat de opdrachtgever de offerte aanvaardt of een opdracht bevestigt, dan wel op het moment dat Cleven Cleaning met de uitvoering aanvangt.",
        ],
      },
      {
        heading: "Artikel 4 — Uitvoering van de werkzaamheden",
        paragraphs: [
          "Cleven Cleaning voert de werkzaamheden naar beste inzicht en vermogen uit, conform de eisen van goed vakmanschap.",
          "De opdrachtgever zorgt ervoor dat Cleven Cleaning toegang heeft tot de te reinigen oppervlakken en dat, indien nodig, water en/of elektriciteit beschikbaar zijn.",
        ],
      },
      {
        heading: "Artikel 5 — Planning en afspraken",
        paragraphs: [
          "Cleven Cleaning werkt met een planningssysteem (CRM) waarmee de opdrachtgever minimaal 24 uur van tevoren bericht ontvangt over een geplande beurt.",
          "Indien een afspraak niet uitkomt, kan deze in overleg en tijdig worden verzet. Bij periodieke abonnementen wordt het schema automatisch doorgepland.",
        ],
      },
      {
        heading: "Artikel 6 — Prijzen en tarieven",
        paragraphs: [
          "Prijzen luiden in euro's. Voor particulieren zijn de genoemde prijzen inclusief btw, tenzij anders vermeld; voor zakelijke opdrachtgevers exclusief btw.",
          "Cleven Cleaning is gerechtigd tarieven jaarlijks te indexeren. Wijzigingen worden tijdig kenbaar gemaakt.",
        ],
      },
      {
        heading: "Artikel 7 — Betaling",
        paragraphs: [
          "Betaling vindt plaats via factuur (iDEAL/overschrijving) na afronding van de werkzaamheden. Particulieren hanteren een betalingstermijn van 14 dagen; voor zakelijke opdrachtgevers en VvE's gelden de op de factuur vermelde termijnen.",
          "Bij niet-tijdige betaling is de opdrachtgever van rechtswege in verzuim en kunnen wettelijke (handels)rente en redelijke incassokosten in rekening worden gebracht.",
        ],
      },
      {
        heading: "Artikel 8 — Annulering en verzetten",
        paragraphs: [
          "Een afspraak kan kosteloos worden geannuleerd of verzet tot uiterlijk 24 uur voor het geplande moment. Bij latere annulering kunnen voorrijkosten in rekening worden gebracht.",
        ],
      },
      {
        heading: "Artikel 9 — Klachten en tevredenheid",
        paragraphs: [
          "Cleven Cleaning streeft naar 100% klanttevredenheid. Klachten over de uitvoering dienen binnen 5 werkdagen na uitvoering te worden gemeld via de contactgegevens onderaan deze pagina.",
          "Bij een gegronde klacht komt Cleven Cleaning zo spoedig mogelijk terug om het werk kosteloos te herstellen.",
        ],
      },
      {
        heading: "Artikel 10 — Aansprakelijkheid en verzekering",
        paragraphs: [
          "Cleven Cleaning is verzekerd voor bedrijfsaansprakelijkheid. De aansprakelijkheid is beperkt tot het bedrag dat in het betreffende geval door de verzekeraar wordt uitgekeerd.",
          "Cleven Cleaning is niet aansprakelijk voor schade die het gevolg is van gebreken aan het pand, bestaande beschadigingen, of onjuiste of onvolledige informatie van de opdrachtgever.",
        ],
      },
      {
        heading: "Artikel 11 — Overmacht",
        paragraphs: [
          "In geval van overmacht (waaronder extreme weersomstandigheden, ziekte of storingen) is Cleven Cleaning gerechtigd de uitvoering op te schorten zonder tot schadevergoeding gehouden te zijn. De werkzaamheden worden zo spoedig mogelijk opnieuw ingepland.",
        ],
      },
      {
        heading: "Artikel 12 — Toepasselijk recht en geschillen",
        paragraphs: [
          "Op alle overeenkomsten is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in het arrondissement waar Cleven Cleaning is gevestigd, tenzij de wet dwingend anders bepaalt.",
        ],
      },
    ],
  },

  privacybeleid: {
    slug: "privacybeleid",
    title: "Privacybeleid",
    metaTitle: "Privacybeleid | Cleven Cleaning",
    metaDescription:
      "Lees hoe Cleven Cleaning omgaat met uw persoonsgegevens conform de AVG (GDPR).",
    updated: "februari 2026",
    intro:
      "Cleven Cleaning hecht veel waarde aan de bescherming van uw persoonsgegevens. In dit privacybeleid leggen wij uit welke gegevens wij verzamelen, waarom, en welke rechten u heeft. Wij verwerken persoonsgegevens in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG).",
    sections: [
      {
        heading: "1. Verwerkingsverantwoordelijke",
        paragraphs: [
          "Cleven Cleaning, gevestigd te Rosmalen en ingeschreven bij de Kamer van Koophandel onder nummer 75029979, is verantwoordelijk voor de verwerking van persoonsgegevens zoals beschreven in dit beleid.",
        ],
      },
      {
        heading: "2. Welke gegevens verzamelen wij",
        items: [
          "Contactgegevens die u zelf verstrekt via het contactformulier of de prijscalculator: naam, e-mailadres, telefoonnummer en de inhoud van uw bericht.",
          "Adres- en pandgegevens die nodig zijn om een offerte te maken of werkzaamheden uit te voeren.",
          "Technische gegevens via cookies en analytische tools (zie onze cookieverklaring), zoals IP-adres en gebruik van de website.",
        ],
      },
      {
        heading: "3. Doeleinden van de verwerking",
        items: [
          "Het opstellen van offertes en het uitvoeren van overeenkomsten.",
          "Het plannen van afspraken en het versturen van herinneringen (bijv. 24 uur vooraf).",
          "Het beantwoorden van vragen en het onderhouden van contact.",
          "Facturatie en administratie.",
          "Het verbeteren van onze website en dienstverlening.",
        ],
      },
      {
        heading: "4. Rechtsgrondslagen",
        paragraphs: [
          "Wij verwerken uw gegevens op basis van de uitvoering van een overeenkomst, uw toestemming (bijvoorbeeld bij het contactformulier), een wettelijke verplichting (zoals de fiscale bewaarplicht) of ons gerechtvaardigd belang (zoals een goede bedrijfsvoering).",
        ],
      },
      {
        heading: "5. Bewaartermijnen",
        paragraphs: [
          "Wij bewaren uw gegevens niet langer dan noodzakelijk. Administratieve en fiscale gegevens bewaren wij conform de wettelijke bewaarplicht (doorgaans 7 jaar). Contactgegevens uit aanvragen die niet tot een opdracht leiden, verwijderen wij binnen een redelijke termijn.",
        ],
      },
      {
        heading: "6. Delen met derden",
        paragraphs: [
          "Wij verstrekken uw gegevens uitsluitend aan derden voor zover dat nodig is voor onze dienstverlening of op grond van een wettelijke verplichting. Met verwerkers (zoals onze e-mail-, hosting- en planningsleveranciers) sluiten wij verwerkersovereenkomsten. Wij verkopen uw gegevens nooit.",
        ],
      },
      {
        heading: "7. Cookies",
        paragraphs: [
          "Onze website maakt gebruik van cookies. Meer informatie vindt u in onze cookieverklaring.",
        ],
      },
      {
        heading: "8. Uw rechten",
        items: [
          "Recht op inzage in de gegevens die wij van u verwerken.",
          "Recht op rectificatie en aanvulling.",
          "Recht op verwijdering ('vergeten worden').",
          "Recht op beperking en bezwaar tegen de verwerking.",
          "Recht op dataportabiliteit.",
          "U kunt een verzoek indienen via de contactgegevens onderaan deze pagina. Ook heeft u het recht een klacht in te dienen bij de Autoriteit Persoonsgegevens.",
        ],
      },
      {
        heading: "9. Beveiliging",
        paragraphs: [
          "Wij nemen passende technische en organisatorische maatregelen om uw gegevens te beschermen tegen verlies of onrechtmatige verwerking.",
        ],
      },
      {
        heading: "10. Wijzigingen",
        paragraphs: [
          "Wij kunnen dit privacybeleid van tijd tot tijd aanpassen. De meest actuele versie vindt u altijd op deze pagina.",
        ],
      },
    ],
  },

  cookieverklaring: {
    slug: "cookieverklaring",
    title: "Cookieverklaring",
    metaTitle: "Cookieverklaring | Cleven Cleaning",
    metaDescription:
      "Informatie over de cookies die Cleven Cleaning op de website gebruikt en hoe u deze kunt beheren.",
    updated: "februari 2026",
    intro:
      "Op de website van Cleven Cleaning maken wij gebruik van cookies. In deze cookieverklaring leggen wij uit wat cookies zijn, welke wij gebruiken en hoe u deze kunt beheren.",
    sections: [
      {
        heading: "1. Wat zijn cookies?",
        paragraphs: [
          "Cookies zijn kleine tekstbestanden die bij een bezoek aan de website op uw apparaat worden opgeslagen. Ze helpen om de website goed te laten werken en het gebruik te analyseren.",
        ],
      },
      {
        heading: "2. Welke cookies gebruiken wij?",
        items: [
          "Functionele cookies: noodzakelijk om de website en onderdelen zoals de prijscalculator goed te laten functioneren. Ook uw cookievoorkeur slaan wij lokaal op.",
          "Analytische cookies (Google Analytics 4): alleen na uw toestemming via de cookiebanner. Wij meten geanonimiseerd (IP-adres gemaskeerd) welke pagina's worden bezocht en op welke knoppen wordt geklikt, zodat wij de website kunnen verbeteren.",
          "Cookies van derden: onderdelen zoals de ingesloten prijscalculator kunnen eigen cookies plaatsen.",
        ],
      },
      {
        heading: "3. Toestemming",
        paragraphs: [
          "Voor het plaatsen van niet-noodzakelijke (analytische) cookies vragen wij uw toestemming via de cookiebanner. Zonder toestemming worden geen analytische cookies geplaatst. U kunt uw keuze op elk moment wijzigen via de link 'Cookie-instellingen' onderaan de website.",
        ],
      },
      {
        heading: "4. Cookies beheren en verwijderen",
        paragraphs: [
          "U kunt cookies te allen tijde verwijderen of blokkeren via de instellingen van uw browser. Houd er rekening mee dat de website hierdoor mogelijk niet volledig functioneert.",
        ],
      },
      {
        heading: "5. Wijzigingen",
        paragraphs: [
          "Wij kunnen deze cookieverklaring aanpassen. De actuele versie staat altijd op deze pagina.",
        ],
      },
    ],
  },
};

export const COMPANY_INFO = COMPANY;

export const getLegalDoc = (slug) => legalDocs[slug];
